// Utilitaires pour le sélecteur de jour (Aujourd'hui / Demain / J+2 ...).

const JOURS = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

export function dateISO(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  // toISOString() convertit en UTC avant de découper la date: passé minuit
  // heure de Paris (UTC+1 ou +2), ça fait retomber sur la veille. On
  // recompose la date à la main à partir des composants locaux.
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function libelleJour(offsetDays) {
  if (offsetDays === 0) return "Aujourd'hui";
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const jour = JOURS[d.getDay()];
  const jj = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${jour}. ${jj}/${mm}`;
}
